module.exports = __webpack_public_path__ + "img/cicada-top-curve.85ef912.png";